import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/shell/app';
import { appConfig } from './app/shell/app.config';

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
